export { default } from './SkeletonFaresCarouselBackgroundImageMobile';
